export const visibilityCheck = (userPreference, requiredUserPreferences)=>{
    if(requiredUserPreferences.includes(userPreference)){
        return undefined;
    }
    else
    {
        return 'none';
    }
}